module.exports = __webpack_public_path__ + "images/compass__bg-bc573f.svg";